import { ZCatalog } from "src/business/catalog/ZCatalog";
import { ZCatalogUpdate } from "src/business/catalog/ZCatalogUpdate";
import {
  apiExtensionsToForm,
  formExtensionsToWrite,
  ZExtensionFormBinding,
} from "src/business/extensionBindings";
import { ZSidLabel } from "src/types";

export type CatalogCardValues = Pick<
  ZCatalog,
  "classifiers" | "description" | "name" | "permissions"
> & {
  displayAttribute?: string | null;
  schema?: ZSidLabel | null;
  extensions?: ZExtensionFormBinding[];
};

export type FnCatalogSave = (values: CatalogCardValues) => Promise<ZCatalog>;

export const catalog2edit = (values?: ZCatalog): CatalogCardValues => ({
  name: values?.name ?? "",
  description: values?.description,
  classifiers: values?.classifiers ?? [],
  schema: values?.schema,
  displayAttribute: values?.displayAttribute?.id,
  permissions: values?.permissions,
  extensions: apiExtensionsToForm(values?.extensions),
});

export const edit2catalog = ({
  name,
  description,
  schema,
  displayAttribute,
  classifiers,
  permissions,
  extensions,
}: CatalogCardValues): ZCatalogUpdate => {
  if (!schema) throw Error("Не указана спецификация");
  if (!displayAttribute) throw Error("Не указан атрибут для названия");
  return {
    name,
    description,
    schemaId: schema.id,
    displayAttributeId: displayAttribute,
    classifierIds: classifiers?.map(({ id }) => id) ?? [],
    permissions,
    extensions: formExtensionsToWrite(extensions ?? []),
  };
};
